export enum DashboardNotificationActionType {
  dismiss = 'neutral',
  negative = 'negative',
  affirmative = 'affirmative',
}

export type DashboardNotificationAction = {
  text: string;
  type: DashboardNotificationActionType;
  url: string;
};

export enum DashboardNotificationType {
  announcementReceived = 'announcement_received',
  shiftTaskCompleted = 'shift_task_completed',
  shiftTaskDueSoon = 'shift_task_due_soon',
  shiftTaskOverdue = 'shift_task_overdue',
  timesheetUpdate = 'timesheet_update',
  timesheetCreatePendingConsent = 'timesheet_create_pending_consent',
  timesheetEditPendingConsent = 'timesheet_edit_pending_consent',
  timesheetDeletePendingConsent = 'timesheet_delete_pending_consent',
  timesheetEditConsentGiven = 'timesheet_edit_consent_given',
  timesheetEditConsentDenied = 'timesheet_edit_consent_denied',
  timesheetEditedBySomeone = 'timesheet_edited_by_someone',
  timesheetDeletedBySomeone = 'timesheet_deleted_by_someone',
  shiftFeedbackRequested = 'shift_feedback_requested',
}

export enum DashboardNotificationRoute {
  timeclockTimesheets = '/timeclock/timesheets',
  announcementsView = '/announcements/view',
  clockIn = '/shifts/view/clockin',
}
